export enum StandByModes {
	Duration = 0,
	EndDate = 1,
}
